
<div class="digestModal">
    <h2 mat-dialog-title>
        {{'add_digest.title' | translate}}
    </h2>
    
    @if(orgUnits && daysOfMonth && daysOfWeek && frequencies) {
        <mat-dialog-content class="dialog-content-pad-10">
            <form>
                <div class="form-group mb-2">
                    <label class="col-form-label">{{'add_digest.frequency' | translate}}</label>
                    <select [(ngModel)]="digest.frequency"
                            name="frequency" class="form-select"
                            (change)="onUpdateFrequency()">
                            @for(frequency of frequencies; track frequency.value) {
                                <option [ngValue]="frequency.value">{{frequency.label}}</option>
                            }
                    </select>
                </div>
    
                @switch(digest.frequency) {
                    @case('weekly') {
                        <div class="form-group mb-2">
                            <label class="col-form-label">{{'add_digest.frequency.weekly' | translate}}</label>
                            <select [(ngModel)]="digest.dayOfDigest"
                                    name="dayOfDigest" class="form-select">
                                    @for(day of daysOfWeek; track day.value) {
                                        <option [ngValue]="day.value">{{day.label}}</option>
                                    }
                            </select>
                        </div>
                    }
                    @case('monthly') {
                        <div class="form-group mb-2">
                            <label class="col-form-label">{{'add_digest.frequency.monthly' | translate}}</label>
                            <select [(ngModel)]="digest.dayOfDigest"
                                    name="dayOfDigest" class="form-select">
                                    @for(day of daysOfMonth; track day) {
                                        <option [ngValue]="day">{{day}}</option>
                                    }
                            </select>
                        </div>
                    }
                }
            </form>
    
            <div>
                <div class="form-group mb-2">
                    <label class="col-form-label">{{'add_digest.frequency.filter' | translate}}</label>
                    <tm-filter-editor class="pe-5"
                                        [filter]="digest.decodedFilter"
                                        [orgUnits]="orgUnits"
                                        (filterChange)="save_filters($event)">
                    </tm-filter-editor>
                </div>
            </div>
        </mat-dialog-content>
    }
    
    <mat-dialog-actions class="justify-content-center">
        <button type="button"
                class="btn btn-default"
                (click)="cancel()">{{'cancel' | translate}}</button>
    
        <button type="button"
                class="btn btn-primary"
                [disabled]="digest.decodedFilter.predicates.length === 0 || !digest.frequency || !digest.dayOfDigest"
                (click)="create(digest)">
            @if(digest.id) {
                <span>{{'update' | translate}}</span>
            }
            @else{
                <span>{{'add_digest.create' | translate}}</span>
            }
        </button>
    </mat-dialog-actions>
     
</div>